"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FlexLayout = _interopRequireDefault(require("../Layouts/FlexLayout"));

var _Input2 = _interopRequireDefault(require("../Input/Input"));

var _InputWidthProvider = _interopRequireDefault(require("../Utility/InputWidthProvider"));

var _VerticalSeparator = _interopRequireDefault(require("../Separator/VerticalSeparator"));

var _TextLabel = _interopRequireDefault(require("../Typography/TextLabel"));

var _Rail = _interopRequireDefault(require("./Rail"));

var _SliderUtil = require("./SliderUtil");

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Input = (0, _InputWidthProvider.default)(_Input2.default);

var Slider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Slider, _React$Component);

  function Slider(props) {
    var _this;

    _classCallCheck(this, Slider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Slider).call(this, props)); // If default prop is not available use 0 for normal slider
    // and use [0, 0] - array for range slider

    _this.handleOnChange = function (value) {
      _this.preValue = value;

      _this.setState({
        inputValue: value
      });

      if (_this.props.onChange) {
        _this.props.onChange(value);
      }
    };

    _this.handleOnMinus = function (isShift) {
      var step = _this.props.step || 1;

      if (isShift) {
        step = step * 10;
      }

      _this._addOrMinus(-step);
    };

    _this.handleOnAdd = function (isShift) {
      var step = _this.props.step || 1;

      if (isShift) {
        step = step * 10;
      }

      _this._addOrMinus(step);
    };

    _this.onInputChange = function (e) {
      var _this$props = _this.props,
          range = _this$props.range,
          min = _this$props.min,
          max = _this$props.max;
      var value;
      var targetValue = e.target.value;

      if (targetValue.length === 0 || targetValue === '-') {
        value = targetValue;
      } else if (targetValue > max || targetValue < min) {
        // Upper bound number should not be smaller than min
        if (min > 0 && targetValue < min && parseFloat(targetValue) >= 0) {
          value = parseFloat(targetValue);
        } else if (min < 0 && targetValue < min && targetValue >= -(0, _SliderUtil.getMaxAllowedInput)(-min)) {
          // Lower bound should not smaller than the minimum allowed input.
          value = parseFloat(targetValue);
        } else if (targetValue > max && targetValue <= (0, _SliderUtil.getMaxAllowedInput)(max)) {
          // Upper bound should not exceed the maximum allowed input.
          value = parseFloat(targetValue);
        } else {
          value = range ? _this.preValue[1] : _this.preValue;
        }
      } else if (targetValue && !isNaN(targetValue)) {
        value = parseFloat(targetValue);
      } else {
        value = range ? _this.preValue[1] : _this.preValue;
      }

      var rangeVal = value;

      if (_this.props.range) {
        rangeVal = [_this.state.inputValue[0], value];
      }

      _this.handleOnChange(rangeVal);
    };

    _this.onInputRangeStartChange = function (e) {
      var value;
      var targetValue = e.target.value;

      if (targetValue.length === 0 || targetValue === '-') {
        value = targetValue;
      } else if (targetValue > _this.state.inputValue[1] || targetValue < _this.props.min) {
        // Lower bound number should not exceed upper bound
        // or smaller than min value
        if (_this.props.min > 0 && targetValue < _this.props.min && parseFloat(targetValue) >= 0) {
          value = parseFloat(targetValue);
        } else if (_this.props.min < 0 && targetValue < _this.props.min && targetValue >= -(0, _SliderUtil.getMaxAllowedInput)(-_this.props.min)) {
          // Lower bound should not smaller than the minimum allowed input.
          value = parseFloat(targetValue);
        } else {
          value = _this.preValue[0];
        }
      } else if (targetValue && !isNaN(targetValue)) {
        value = parseFloat(targetValue);
      } else {
        value = _this.preValue[0];
      }

      var rangeVal = [value, _this.state.inputValue[1]];

      _this.handleOnChange(rangeVal);
    };

    _this.handleKeyEvent = function (event) {
      var isShift = event.shiftKey;

      switch (event.key) {
        case 'ArrowUp':
          event.preventDefault();

          _this.handleOnAdd(isShift);

          break;

        case 'ArrowDown':
          event.preventDefault();

          _this.handleOnMinus(isShift);

          break;

        default:
          break;
      }
    };

    _this.handleInputBlur = function () {
      _this.setValidatedValue();
    };

    _this.state = {
      inputValue: _this.props.value ? _this.props.value : _this.props.defaultValue,
      width: (0, _SliderUtil.calculateInputWidth)(props.max, Boolean(props.InputLabel))
    };
    _this.preValue = _this.state.inputValue;
    _this.focused = null;
    return _this;
  }

  _createClass(Slider, [{
    key: "setValidatedValue",
    // Validate the input value to a reasonable range or number.
    value: function setValidatedValue() {
      if (this.props.range) {
        // If lowerbound is larger than upperbound, reset the upperbound.
        var newValue = (0, _SliderUtil.getSliderValue)(this.state.inputValue, this.props);

        if (newValue[1] < newValue[0]) {
          newValue[1] = newValue[0];
        }

        this.handleOnChange(newValue);
      } else {
        this.handleOnChange((0, _SliderUtil.getSliderValue)(this.state.inputValue, this.props));
      }
    } // OnChange event of slider

  }, {
    key: "_addOrMinus",

    /**
     * This is a helper function to increase or decrease a current
     * value.
     * @param {number} step : use negative number to decrease and
     *   positive number to increase.
     * @private
     */
    value: function _addOrMinus(step) {
      var inputValue = this.state.inputValue;
      var _this$props2 = this.props,
          min = _this$props2.min,
          max = _this$props2.max;

      if (this.focused !== null) {
        // change value of focused input
        var value;

        if (this.props.range) {
          value = inputValue[this.focused];
        } else {
          value = inputValue;
        }

        var newNumber;

        if (value === '') {
          newNumber = step;
        } else {
          newNumber = parseFloat(value) + step;
        }

        if (newNumber > max) {
          newNumber = max;
        } else if (newNumber < min) {
          newNumber = min;
        }

        var rangeVal = inputValue;

        if (this.props.range) {
          if (this.focused === 0) {
            newNumber = newNumber > inputValue[1] ? inputValue[1] : newNumber;
          } else {
            newNumber = newNumber < inputValue[0] ? inputValue[0] : newNumber;
          }

          rangeVal[this.focused] = newNumber;
        } else {
          rangeVal = newNumber;
        }

        this.handleOnChange(rangeVal);
      }
    }
    /**
     * OnChange of the input next to slider
     * In Slider, only Integer input is allowed and will work.
     * @param {object} e - event object
     */

  }, {
    key: "renderInput",

    /**
     * @param {number} value - value props to pass to input component
     * @param {number} index - input index (start/end)
     * @returns {XML} - input component
     */
    value: function renderInput(value, index) {
      var _this2 = this;

      var inputSuffix = '';

      if (this.props.InputLabel) {
        inputSuffix = _react.default.createElement(_FlexLayout.default, {
          alignItems: "center",
          itemSpacing: "10px"
        }, _react.default.createElement(_VerticalSeparator.default, null), _react.default.createElement(_TextLabel.default, null, this.props.InputLabel));
      }

      var onChange = index === 1 ? this.onInputChange : this.onInputRangeStartChange;
      var rangeInputProps;

      if (this.props.range) {
        rangeInputProps = index === 1 ? _objectSpread({}, this.props.maxInputProps) : _objectSpread({}, this.props.minInputProps);
      }

      return _react.default.createElement(Input, _extends({
        value: value,
        onChange: onChange,
        onKeyDown: this.handleKeyEvent,
        onBlur: this.handleInputBlur,
        onFocus: function onFocus() {
          _this2.focused = index;
        },
        suffix: inputSuffix,
        style: {
          minWidth: this.state.width
        }
      }, this.props.inputProps, rangeInputProps));
    }
  }, {
    key: "renderSliderRail",
    value: function renderSliderRail() {
      return _react.default.createElement(_Rail.default, _extends({
        onChange: this.handleOnChange,
        value: this.state.inputValue,
        min: this.props.min,
        max: this.props.max
      }, this.props));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          min = _this$props3.min,
          max = _this$props3.max,
          wrapperProps = _this$props3.wrapperProps;
      var rangeStartInput;
      var inputValue = this.state.inputValue;

      if (this.props.range) {
        rangeStartInput = this.renderInput(this.state.inputValue[0], 0);
        inputValue = this.state.inputValue[1];
      }

      var sliderType = this.props.range ? 'range' : 'default';
      return _react.default.createElement(_FlexLayout.default, _extends({
        itemSpacing: "10px",
        className: (0, _classnames.default)(className, "".concat(_ThemeManager.default.getVar('classPrefix'), "-slider")),
        "date-type": sliderType
      }, wrapperProps), this.props.showInput ? rangeStartInput : '', _react.default.createElement("span", {
        className: "slider-start-label"
      }, min), this.renderSliderRail(), _react.default.createElement("span", {
        className: "slider-end-label"
      }, max), this.props.showInput ? this.renderInput(inputValue, 1) : '');
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var width = (0, _SliderUtil.calculateInputWidth)(props.max, Boolean(props.InputLabel));
      var newValue = props.value;

      if (width === state.width) {
        // If there is value defined
        if (newValue) {
          if (props.range) {
            if (newValue[0] === state.inputValue[0] && newValue[1] === state.inputValue[1]) {
              return null;
            }

            return _objectSpread({}, state, {
              inputValue: (0, _SliderUtil.getSliderValue)(newValue, props)
            });
          }

          if (newValue === state.inputValue) {
            return null;
          }

          return _objectSpread({}, state, {
            inputValue: (0, _SliderUtil.getSliderValue)(newValue, props)
          });
        }

        return null;
      }

      return _objectSpread({}, state, {
        width: width
      });
    }
  }]);

  return Slider;
}(_react.default.Component);

exports.default = Slider;
Slider.defaultProps = {
  showInput: true,
  range: false,
  defaultValue: 0,
  min: 0,
  max: 100
};
Slider.propTypes = {
  /**
   * Customize additional class name.
   */
  className: _propTypes.default.string,

  /**
   * Slider with single value or range.
   */
  range: _propTypes.default.bool,

  /**
   * Slider with tooltip
   */
  tooltip: _propTypes.default.bool,

  /**
   * Show input box boolean
   */
  showInput: _propTypes.default.bool,

  /**
   * Label for the input box of the slider
   */
  InputLabel: _propTypes.default.string,

  /**
   * Minimum value of the slider
   */
  min: _propTypes.default.number,

  /**
   * Maximum value of the slider
   * Difference between max and min is better to be within 1000
   * because of pixels on slider is not easily differentiable.
   */
  max: _propTypes.default.number,

  /**
   * Step interval of the slider
   * Step can only be Integer.
   * Step could help to work with larger max value.
   */
  step: _propTypes.default.number,

  /**
   * Callback to handle input value change.
   * onChange will send out parameter of the current slider input value.
   * @param {string|object} value
   */
  onChange: _propTypes.default.func,

  /**
   * Default input value of the the slider.  The number(s)
   * must be within the range of min and max.
   */
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.number]),

  /**
   * The input value.  If an application supply this then the application
   * also need to handle onChange.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.number, _propTypes.default.string]),

  /**
   * Props to be passed to Input component
   */
  inputProps: _propTypes.default.object,

  /**
   * Props to be passed to min Input component when range is defined
   */
  minInputProps: _propTypes.default.object,

  /**
   * Props to be passed to max Input component when range is defined
   */
  maxInputProps: _propTypes.default.object,

  /**
   * Props to pass to Rail component
   */
  railProps: _propTypes.default.object,

  /**
   * Props to pass to Handle component
   */
  handleProps: _propTypes.default.object,

  /**
   * Props to pass to min Handle component when range is defined
   */
  minHandleProps: _propTypes.default.object,

  /**
   * Props to pass to max Handle component when range is defined
   */
  maxHandleProps: _propTypes.default.object,

  /**
   * Props to be passed to wrapping dom element
   */
  wrapperProps: _propTypes.default.object
};